import { CustomColumnGridConfig } from '../types'
import { Box } from '@mui/material'

const columnsConfig: CustomColumnGridConfig[] = [
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'waterCard',
    headerName: 'מספר כ.מים',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'meterNumber',
    headerName: 'מספר מד',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'diameter',
    headerName: 'קוטר מד',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'name',
    headerName: 'שם צרכן',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'payerNumber',
    headerName: 'מספר משלם',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'address',
    headerName: 'כתובת',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'area',
    headerName: 'איזור מדידה',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    minWidth: 150,
    flex: 1,
    width: 250,
    field: 'lastSeen',
    headerName: 'נקלט לאחרונה',
    hideable: true,
    sortComparator: (v1, v2) => {
      const parseDate = (val: string) => {
        if (!val) return 0
        const [year, month, day] = val.split('T')[0].split('-').map(Number)
        return new Date(year, month - 1, day, 0, 0, 0, 0).getTime()
      }
      return parseDate(v1) - parseDate(v2)
    },
    disableAggregation: true,
    filterSpec: { kind: 'date' },
    filterable: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'capacity',
    headerName: 'קריאה',
    filterSpec: { kind: 'number' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  {
    flex: 1,
    minWidth: 150,
    field: 'openAlerts',
    headerName: 'סטטוס',
    hideable: true,
    disableAggregation: true,
    filterSpec: { kind: 'none' },
    filterable: false,
    renderCell: (params: any) => {
      if (params.value) {
        return (
          <Box
            sx={{
              display: 'flex',
              height: 'fit-content',
              gap: 1,
              overflowY: 'auto',
            }}
          >
            {params.value.map((alert: any, index: number) => {
              return (
                <div key={index}>
                  {alert.name}{' '}
                  {index + 1 !== params.value.length && <span>,</span>}
                </div>
              )
            })}
          </Box>
        )
      } else {
        return <div>-</div>
      }
    },
  },
]

export default columnsConfig
